/**
 * Need to disable autocomplete on all inputs due to issues with the framework not
 * getting these events and the model falling out of sync with the view
 *
 * Also need to sanitize input of special characters for PCI certification
 *      - Elements containing "san-exclude" attribute will not be sanitized and will be allowed to
 *        contain special characters
 */

// TODO do not use this global. We need to remove it.
const restrictedList = '';

angular.module('qkr').directive('input', () => ({
        restrict: 'E',
        link(scope, elem, attrs) {
            elem.attr('autocomplete', 'off');

            if (elem[0].type !== 'password' && elem[0].type !== 'email' && elem[0].type !== 'button' &&
                attrs.sanExclude === undefined && attrs.mcAmountInput === undefined &&
                attrs.mcAmount === undefined && attrs.numeric === undefined) {
                elem.on('keypress', (event) => isAcceptableKeyPress(event));

                elem.on('change', (e) => {

                    //quick fix to avoid throw error, jquery file
                    if( elem[0] && elem[0].type !== 'file') {
                        angular.element(elem).val(sanitizeInput(angular.element(elem).val()));
                        elem.trigger('input');
                    }


                    return false;
                });
            }

            function isAcceptableKeyPress(event) {
                // Command key
                if (event.metaKey) {
                    return false;
                }

                if (event.which === 0) {
                    // Tab , backspace, arrow keys, delete
                    if (event.keyCode === 46 || event.keyCode === 9 || event.keyCode === 8 || event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40) {
                        return true;
                    } else {
                        return false;
                    }
                }

                const char = String.fromCharCode(event.which);

                // Special chars
                if (restrictedList.indexOf(char) > -1) {
                    return false;
                }

                return true;
            }

            function sanitizeInput(inputString) {
                let result = '';

                angular.forEach(inputString, (char) => {
                    if (restrictedList.indexOf(char) === -1) {
                        result += char;
                    }
                });

                return result;
            }
        }
    }));

angular.module('qkr').directive('textarea', () => ({
        restrict: 'E',
        link(scope, elem, attrs) {
            if (attrs.sanExclude === undefined) {
                elem.on('keypress', (event) => isAcceptableKeyPress(event));

                elem.on('change', (e) => {
                    angular.element(elem).val(sanitizeInput(angular.element(elem).val()));
                    elem.trigger('input');
                    return false;
                });
            }

            function isAcceptableKeyPress(event) {
                // Command key
                if (event.metaKey) {
                    return false;
                }

                if (event.which === 0) {
                    // Tab , backspace, arrow keys, delete
                    if (event.keyCode === 46 || event.keyCode === 9 || event.keyCode === 8 || event.keyCode === 37 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 40) {
                        return true;
                    } else {
                        return false;
                    }
                }

                const char = String.fromCharCode(event.which);

                // Special chars
                if (restrictedList.indexOf(char) > -1) {
                    return false;
                }

                return true;
            }

            function sanitizeInput(inputString) {
                let result = '';

                angular.forEach(inputString, (char) => {
                    if (restrictedList.indexOf(char) === -1) {
                        result += char;
                    }
                });

                return result;
            }
        }
    }));

/**
 * Declaring this as a directive so we don't get a warning when adding the san-exclude (sanitization exclude) attribute to elements we don't want to be sanitized
 *  - If you still get the warning then download the AngularJS plugin for IntelliJ
 * */
angular.module('qkr').directive('sanExclude', () => ({
        restrict: 'A'
    }));



// WEBPACK FOOTER //
// ./src/directives/input_sanitize.js